import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import { PaymentCardModel, PaymentCardTypes } from '../../../../modules/finanzas/paymentcard/paymentcard.model';

export interface PaymentCardListFilter {
  page: number;
  pageSize: number;
  search?: string;
  sortField?: string;
  sortDirection?: string;
}

export interface PaymentCardListResult {
  items: PaymentCardModel[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class PaymentCardReadService {
  constructor(private http: HttpClient) { }

  list(cardType: number, filter: PaymentCardListFilter): Promise<PaymentCardListResult> {
    const resource = cardType === PaymentCardTypes.Tarjeta_Debito ? 'payment-card-debits' : 'payment-card-credits';
    const fallback = 'No se pudo cargar la lista de tarjetas';
    return firstValueFrom(this.http.post<any>(`${environment.apiUrl}/api/v2/${resource}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
        };
      });
  }
}
